function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgBankCard = function SvgBankCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 23,
    rx: 3.27273,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.66853,
    cy: 7.27815,
    r: 2.77791,
    fill: "#E01420"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.3892,
    cy: 7.27815,
    r: 2.77791,
    fill: "#FEE12B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 15.3352,
    width: 5.55582,
    height: 1.11116,
    rx: 0.555582,
    fill: "#8D92A4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3906,
    y: 15.3352,
    width: 5.55582,
    height: 1.11116,
    rx: 0.555582,
    fill: "#8D92A4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.834,
    y: 15.3352,
    width: 5.55582,
    height: 1.11116,
    rx: 0.555582,
    fill: "#8D92A4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2246,
    y: 15.3352,
    width: 5.55582,
    height: 1.11116,
    rx: 0.555582,
    fill: "#8D92A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52846 9.34216C9.09164 8.83377 9.44559 8.09799 9.44559 7.27954C9.44559 6.46109 9.09164 5.72531 8.52846 5.21692C7.96528 5.72531 7.61133 6.46109 7.61133 7.27954C7.61133 8.09799 7.96528 8.83377 8.52846 9.34216Z",
    fill: "#FF8601"
  }));
};
export default SvgBankCard;